import type { FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { DimensionField } from "../../../../../../../../../api/types/svTypes.ts";
import BlankZeroMenuItem from "../../../common/fields/field-options/BlankZeroMenuItem.tsx";
import ReverseSignMenuItem from "../../../common/fields/field-options/ReverseSignMenuItem.tsx";
import PivotFieldMenuItem from "./menuItems/PivotFieldMenuItem";

export interface Props {
  field: DimensionField;
  saveChanges: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  readonly: boolean;
}
const AggregationOptionsComponent = ({ field, saveChanges, readonly }: Props) => (
  <>
    <BlankZeroMenuItem field={field} saveChanges={saveChanges} readonly={readonly} />
    <ReverseSignMenuItem field={field} saveChanges={saveChanges} readonly={readonly} />
    <PivotFieldMenuItem field={field} saveChanges={saveChanges} readonly={readonly} />
  </>
);

export default AggregationOptionsComponent;
